import React, { useState } from 'react';
import homeImg1 from '@/static/home/pic01-EN.png';
import homeImg2 from '@/static/home/pic02-EN.png';
import homeImg3 from '@/static/home/pic03-EN.png';
import homeImg4 from '@/static/home/pic04-EN.png';
import homeImg5 from '@/static/home/pic05-EN.png';
import homeImg6 from '@/static/home/pic06-EN.png';
import homeCNImg1 from '@/static/home/pic01-CN.png';
import homeCNImg2 from '@/static/home/pic02-CN.png';
import homeCNImg3 from '@/static/home/pic03-CN.png';
import homeCNImg4 from '@/static/home/pic04-CN.png';
import homeCNImg5 from '@/static/home/pic05-CN.png';
import homeCNImg6 from '@/static/home/pic06-CN.png';
import Header from '@/components/header';
import style from './index.module.css';
import LazyLoad from 'react-lazyload';

function HomePage() {

  const [curLangLabel, setLang] = useState('english');
  const homeCNImgList = [
    { img: homeCNImg1, alt: '' },
    { img: homeCNImg2, alt: '' },
    { img: homeCNImg3, alt: '' },
    { img: homeCNImg4, alt: '' },
    { img: homeCNImg5, alt: '' },
    { img: homeCNImg6, alt: '' },
  ];
  const homeENImgList = [
    { img: homeImg1, alt: '' },
    { img: homeImg2, alt: '' },
    { img: homeImg3, alt: '' },
    { img: homeImg4, alt: '' },
    { img: homeImg5, alt: '' },
    { img: homeImg6, alt: '' },
  ];

  function onChangeLang(type:any) {
    setLang(type);
  }

  return (
    <div className={style.homePage}>
      <Header changeLang={onChangeLang} />
      <div className={style.container}>
        {
          curLangLabel === 'english'
          ? homeENImgList.map((item, index) => {
            return <LazyLoad><img src={item.img} alt={item.alt} className={style.imgItem} key={index}/></LazyLoad>;
          })
          : homeCNImgList.map((item, index) => {
            return <LazyLoad>
              <img src={item.img} alt={item.alt} className={style.imgItem} key={index}/>
            </LazyLoad>;
          })
        }
      </div>
    </div>
  );
}

export default HomePage;
